import React, { Component } from 'react'
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import NewsLetter from '../../components/NewsLetter/NewsLetter.js';
import { fetchContact } from '../../redux/actions';
import ReactMarkdown from 'react-markdown';
import './Footer.css';
import { Link } from 'react-router-dom';

class Footer extends Component {

  componentDidMount()
  {
    const locale = this.props.intl.locale;
    if (!this.props.contact.header) {
      this.props.fetchContact(locale);
    }
  }
  render() {
    return (
        <div>
            <footer className="app-footer">
              <div>
                {this.props.contact.footerFirstColumn && <ReactMarkdown source={this.props.contact.footerFirstColumn} softBreak="br" />}                
                {this.props.contact.footerLinks && this.props.contact.footerLinks.map(link => 
                  <Link className="footer-link" to={`/${link.fields.slug}`} key={link.sys.id}>{link.fields.title}</Link>
                )}
              </div>
              <NewsLetter/>
              <div>
                <h4>&nbsp;</h4>
                <a href="https://www.farang.fi/" className="footer-link">Farang</a>
                <a href="https://www.gaijin.fi/" className="footer-link">Gaijin</a>
                <a href="https://www.ravintolabronda.fi/" className="footer-link">Bronda</a>
                <a href="https://www.levain.fi/" className="footer-link">Levain</a>
                <a href="https://catfish.fi/" className="footer-link">Catfish</a>
                <a href="https://boulevard.fi/" className="footer-link">Boulevard</a>
                <a href="https://thegrand.fi/" className="footer-link">The Grand</a>                
				<a href="https://www.goldfish.fi/" className="footer-link">Goldfish</a>
                <a href="http://farang.se/" className="footer-link">Farang Stockholm</a>
                <Link to="/premium-catering" className="footer-link">Premium Catering</Link>
              </div>
            </footer>
        </div>
    )
  }
}

Footer.propTypes = {
  intl: intlShape.isRequired,
}

const mapStateToProps = state => ({
  contact:state.contact
});

const mapDispatchToProps = {
  fetchContact
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Footer));



// WEBPACK FOOTER //
// ./src/containers/Footer/Footer.js